import { render, staticRenderFns } from "./RelatorioLogSolicitacaoFormacao.vue?vue&type=template&id=161ff263&scoped=true"
import script from "./RelatorioLogSolicitacaoFormacao.vue?vue&type=script&lang=js"
export * from "./RelatorioLogSolicitacaoFormacao.vue?vue&type=script&lang=js"
import style0 from "./RelatorioLogSolicitacaoFormacao.vue?vue&type=style&index=0&id=161ff263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ff263",
  null
  
)

export default component.exports